import { css } from '@emotion/css';
import { Spacing } from '@snapchat/snap-design-system';

export const adminSettingsSectionClassName = css({
  display: 'flex',
  flexDirection: 'column',
  gap: Spacing.MD,
});
